var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMustangArrow = function SvgMustangArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 277 339"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.3 8c7.4 7.8 78.4 81.4 104.7 108.5 7.5 7.7 19.7 20.3 27.2 28 15.5 15.9 22.8 23.8 22.8 24.5s-4.9 6-19.9 21.5c-7.5 7.7-26.5 27.3-42.2 43.5-15.6 16.2-41.1 42.5-56.5 58.5-15.4 15.9-31.5 32.7-35.8 37.3L1.7 338h111l12.3-12.8c6.8-7 18.3-18.8 25.5-26.2s32.4-33.5 56-58 48.7-50.5 55.9-57.8 13.1-13.7 13.1-14.1c0-.8-15.4-16.9-69-72.1-8.3-8.5-27.4-28.3-42.5-44-15.1-15.6-32.9-34-39.4-40.7L112.7 0H1.8z"
  })));
};
export default SvgMustangArrow;